import './App.css';
import {Routes, Route} from 'react-router-dom';
import Overview from "./pages/Overview";
import SignIn from "./pages/SignIn";

function App() {
    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<Overview/>}></Route>
                <Route path="/Sign-in" element={<SignIn/>}></Route>
            </Routes>
        </div>
    );
}

export default App;
